import { $DOM } from './selectors'

// accesible data object accross app

export const VARS = {
	W: window.innerWidth,
	H: window.innerHeight,
    scrollTop: $DOM.$window.scrollTop(),
}